import * as React from 'react';
import { parse as markdownToHtml } from 'marked';
import { ParseHTML } from './ParseHTML';

export const ParseMarkdown: React.FC<{ content?: string }> = ({ content = '' }) => {
  const html = markdownToHtml(content, { breaks: true });
  return <ParseHTML content={html} />;
};

ParseMarkdown.displayName = 'ParseMarkdown';
